import React from 'react';

import ScatterPlotComponent from './Component';

class ScatterPlotContainer extends React.Component {
  constructor (props) {
    super(props);

    this.state = { showRegressionLine: true };

    this.handleCheckboxChange = ({ target: { checked } }) =>
      this.setState({ showRegressionLine: checked });
  }

  render () {
    return (
      <ScatterPlotComponent
        {...this.state}
        {...this.props}

        onCheckboxChange={this.handleCheckboxChange}
      />
    );
  }
}

export default ScatterPlotContainer;
